<template>
  <v-content>
    <AppBar title="Vändstäd utförd" />
    <v-container>
      <v-row no-gutters>
        <v-col>
          <v-card>
            <v-card-text>
              <div class="d-flex justify-center">
                <v-icon size="56" class="mb-4 primary--text">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <p>
                Du har på datum
                <strong> {{ registrationDate }} </strong> registrerat att
                <strong>{{ cleaning.train_number }}</strong> har förändrat behov
                av vändstäd.
              </p>

              <p>Tack för hjälpen!</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import { format } from 'date-fns'
import { get } from 'vuex-pathify'

export default {
  name: 'CleaningRegistrationCompleted',

  components: {
    AppBar
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!Object.keys(vm.cleaning).length) {
        vm.$router.push('/cleaning')
      }
    })
  },

  computed: {
    cleaning: get('cleaning/data'),

    registrationDate() {
      if (!this.cleaning.date) return '-'
      return format(new Date(this.cleaning.date), 'yyyy-MM-dd')
    }
  }
}
</script>
